import { Navigate } from 'react-router-dom'

import { ROUTES } from '../../../constants/routes'
import useAuthSession from '../../../hooks/useAuthSession'

const PublicOnlyRoute = ({ element }) => {
  const user = useAuthSession()

  return user?.accessToken
    ? <Navigate to={ROUTES.HOME} replace />
    : element
}

export default PublicOnlyRoute
